import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Reviews } from './components/Reviews';
import { ProductCarousel } from './components/ProductCarousel';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { Benefits } from './components/Benefits';
import { VolumesSection } from './components/VolumesSection';
import { TeachingLibrary } from './components/TeachingLibrary';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import type { MetaPixel } from './types/pixel';
const META_PIXEL_ID = '1049314170929647';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-canvas text-mist selection:bg-gold/30 selection:text-white" data-id="element-0" data-mp="38kv0f9whthk">
      <main data-id="element-1" data-mp="3uf5ijp0qyj9u">
        <Hero data-id="element-2" data-mp="d4nv7fl6zi1v" />
        <Reviews data-id="element-3" data-mp="d57h17dyqql6" />
        <ProductCarousel data-id="element-4" data-mp="d3mkjc838xko" />
        <PainPoints data-id="element-5" data-mp="d3wdn8ofjkul" />
        <SolutionReveal data-id="element-6" data-mp="d2bgrcen7ptk" />
        <Benefits data-id="element-7" data-mp="851kpdwr0fwr" />
        <VolumesSection data-id="element-8" data-mp="86meh1b8nutk" />
        <TeachingLibrary data-id="element-9" data-mp="864djrdmssfb" />
        <BonusSection data-id="element-10" data-mp="83qivjmv5i8a" />
        <PricingSection data-id="element-11" data-mp="3gkv0fqj99ncr" />
        <Guarantee data-id="element-12" data-mp="3gmfsn9i3ku7g" />
        <FAQ data-id="element-13" data-mp="3glnzs6fvxakv" />
        <FinalCTA data-id="element-14" data-mp="3gja887keygi2" />
      </main>
      <Footer data-id="element-15" data-mp="3bmtixa1h9w3e" />
      {showPurchaseNotifications && <PurchaseNotifications data-id="element-16" data-mp="3bnuvxk220snr" />}
    </div>;
}